import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="w-full bg-cream-200 py-14 sm:py-20" data-id="element-68" data-mp="vsmkwis5ima0">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-69" data-mp="vu7fg8egu57v">
        <div className="mx-auto max-w-2xl text-center" data-id="element-70" data-mp="qtjo1lmbrmd4">
          <p className="inline-flex items-center gap-1.5 rounded-full bg-clinical-green px-3.5 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-71" data-mp="qw5vll97u1vc">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-72" data-mp="ztyc2sqobfkb" />
            Exclusive bonuses — free today
          </p>
          <h2 className="mt-5 font-display text-[26px] font-bold leading-[1.15] text-navy-900 sm:text-4xl" data-id="element-73" data-mp="1el8curzxtspb">
            Get these 5 professional bonuses{' '}
            <em className="not-italic text-gold-600" data-id="element-74" data-mp="1nkvfti8bf6kh">at no extra cost</em>
          </h2>
          <div className="mt-5 inline-flex flex-col items-center rounded-2xl border border-gold-500/40 bg-white px-5 py-3.5 shadow-card" data-id="element-75" data-mp="1jji8f3pkqvbg">
            <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-navy-700/60" data-id="element-76" data-mp="3pseq6fo3bqfc">
              Total bonus value
            </span>
            <span className="font-display text-3xl font-bold text-gold-600" data-id="element-77" data-mp="2lcoq50sxhrh">
              $147
            </span>
            <span className="text-[11px] font-bold uppercase tracking-wide text-clinical-green" data-id="element-78" data-mp="7lqjwmhb0x83">
              Included free with your purchase
            </span>
          </div>
        </div>

        <div className="mt-10 space-y-5 sm:space-y-6" data-id="element-79" data-mp="gklvyf7151jb">
          {bonuses.map(bonus => <article key={bonus.badge} className="overflow-hidden rounded-3xl border border-navy-900/10 bg-white shadow-card" data-id="element-80" data-mp="lbu3t6spoeud">
              <img src={bonus.image} alt={`${bonus.title} — ${bonus.badge} mockup`} className="block w-full bg-white" width={1280} height={1280} data-id="element-81" data-mp="va9w3d3h5u5g" />

              <div className="p-5 sm:p-6" data-id="element-82" data-mp="amaa61b62ace">
                <div className="flex flex-wrap items-center gap-2" data-id="element-83" data-mp="aiw70quohx3w">
                  <span className="rounded-full bg-navy-900 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.12em] text-gold-300" data-id="element-84" data-mp="5np95zo3bmmw">
                    🎁 {bonus.badge}
                  </span>
                  <span className="rounded-full bg-gold-100 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.12em] text-gold-700" data-id="element-85" data-mp="fiqvknqzeals">
                    Value: {bonus.value}
                  </span>
                </div>

                <h3 className="mt-3.5 font-display text-[20px] font-bold leading-tight text-navy-900 sm:text-2xl" data-id="element-86" data-mp="139wdr9ke9ez9">
                  {bonus.title}
                </h3>
                <p className="mt-2.5 text-[14.5px] leading-relaxed text-navy-700/85" data-id="element-87" data-mp="ybctrepd2d9j">
                  {bonus.description}
                </p>

                {bonus.items ? <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-88" data-mp="303hqd3ht1yql">
                    {bonus.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-89" data-mp="1fknm5lbd546n">
                        <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-clinical-green/10 text-clinical-green" aria-hidden="true" data-id="element-90" data-mp="1ki72qrvj9t1r">
                          <CheckIcon className="h-3 w-3" data-id="element-91" data-mp="1ar2qhzx8smam" />
                        </span>
                        <span className="text-[14px] leading-snug text-navy-800/90" data-id="element-92" data-mp="wvqqpe48c5mu">
                          {item}
                        </span>
                      </li>)}
                  </ul> : null}
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-9 w-full max-w-md" data-id="element-93" data-mp="rwe50wp3h4lu">
          <CTAButton label="I want all 5 bonuses free" subline="Instant access · One-time payment of $27 USD" data-id="element-94" data-mp="2hasqn84tgbd4" />
        </div>
      </div>
    </section>;
}